import type { LoadingColor, LoadingType } from '@presentation/components';
import type { LocationDescriptor } from 'history';
import type { HTMLAttributes, ReactNode } from 'react';
import type { LinkProps } from 'react-router-dom';

export type ButtonSize = 'small' | 'medium' | 'large' | 'xl';

export type ButtonProps = HTMLAttributes<HTMLButtonElement> & ButtonItemProps;

export type ButtonColor =
  | 'transparent'
  | 'light'
  | 'medium'
  | 'dark'
  | 'blue'
  | 'purple'
  | 'yellow'
  | 'red'
  | 'white'
  | 'green'
  | 'whatsappGreen'
  | 'lightBlue';

export interface ButtonItemProps {
  type?: 'button' | 'submit' | 'reset';
  squared?: boolean;
  shadow?: boolean;
  size?: ButtonSize;
  loading?: boolean;
  loadingProps?: {
    type?: LoadingType;
    color?: LoadingColor;
  };
  shrink?: boolean;
  disabled?: boolean;
  breakSpaces?: boolean;
  color?: ButtonColor;
  outlined?: boolean;

  // TODO: colors
  // TODO
  // label: string;
  // className: string;
  // variable: boolean;
  // icon: string;

  // iconSize?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;

  link?: LocationDescriptor;
  linkWrapperProps?: Omit<LinkProps, 'to'>;

  externalLink?: string;
  externalLinkWrapperProps?: Omit<HTMLAttributes<HTMLAnchorElement>, 'href'>;
}

export type ButtonItemUIProps = Omit<
  ButtonItemProps,
  | 'loading'
  | 'loadingProps'
  | 'iconRight'
  | 'iconLeft'
  | 'type'
  | 'link'
  | 'linkWrapperProps'
  | 'externalLink'
  | 'externalLinkWrapperProps'
>;
